import { asyncActionCreator } from 'src/utils/loadingUtils';

export const LOAD_RENT_CALCULATOR = asyncActionCreator('LOAD_RENT_CALCULATOR');
export const LOAD_MSI_DISCOUNTS = asyncActionCreator('LOAD_MSI_DISCOUNTS');
export const CLEAR_RENT_CALCULATOR = 'CLEAR_RENT_CALCULATOR';
export const CLEAR_MSI_DISCOUNTS = 'CLEAR_MSI_DISCOUNTS';
export const SEND_QUOTE_TO_WHATSAPP = asyncActionCreator(
  'SEND_QUOTE_TO_WHATSAPP'
);
export const SEND_AVAL_FORM_LINK = asyncActionCreator('SEND_AVAL_FORM_LINK');
